import { render, staticRenderFns } from "./IndividualDealTableWidget.vue?vue&type=template&id=cf42680a"
import script from "./IndividualDealTableWidget.vue?vue&type=script&lang=js"
export * from "./IndividualDealTableWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports